import * as types from '../types';

function joinGroup(state = {
  isFetching: false,
  didSucceed: false,
}, action) {
  switch (action.type) {
  case types.JOIN_GROUP_REQUEST:
    return { ...state,
        isFetching: true,
        didSucceed: false,
      };

  case types.JOIN_GROUP_SUCCESS:
    return { ...state,
        isFetching: false,
        didSucceed: true,
      };

  case types.JOIN_GROUP_FAILURE:
    return { ...state,
        isFetching: false,
        didSucceed: false,
      };

  default:
    return state;
  }
}

export default joinGroup;



// WEBPACK FOOTER //
// ./src/reducers/joinGroup.js